import { PublicLayout } from '@/components/layout';
import { Hero, Features, HowItWorks, WaitingList, CTA } from '@/components/landing';

const Landing = () => {
  return (
    <PublicLayout>
      <Hero />
      <Features />
      <HowItWorks />
      <WaitingList />
      <CTA />
    </PublicLayout>
  );
};

export default Landing;
